import React, { useEffect, useState } from 'react';
import AppPage from '../common/AppPage';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';

function StatsPage() {
  const [loading, setLoading] = useState(false);
  const [race, setRace] = useState('human');
  const [profession, setProfession] = useState('channeler');
  const [stats, setStats] = useState(null as any[] | null);
  const [professionOptions, setProfessionOptions] = useState(['warrior', 'hunter', 'rogue', 'channeler']);
  const navigate = useNavigate();
  const showDetail = useMatch('/oldstats/:race/:profession/:homeland');

  useEffect(() => {
    setLoading(true);
    const url = `https://wotcodeapi.azurewebsites.net/api/stats/summary`;
    fetch(url).then(resp => resp.json()).then(result => {
      result.forEach((x: any) => {
        x.homelandDisplay = x.homeland.replace(' Trolloc', '').replace('the ', '');
        x.averageStrength = Math.round(x.averageStrength);
        x.averageIntelligence = Math.round(x.averageIntelligence);
        x.averageWillpower = Math.round(x.averageWillpower);
        x.averageDexterity = Math.round(x.averageDexterity);
        x.averageConstitution = Math.round(x.averageConstitution);
        x.averageStatsum = Math.round(x.averageStatsum);
        x.maxTheoreticStatsum = x.maxStrength + x.maxIntelligence + x.maxWillpower + x.maxDexterity + x.maxConstitution;
        x.minTheoreticStatsum = x.minStrength + x.minIntelligence + x.minWillpower + x.minDexterity + x.minConstitution;
        x.averageTheoreticStatsum = Math.round((x.maxTheoreticStatsum + x.minTheoreticStatsum) / 2);
      });
      setLoading(false);
      setStats(result);
    });
  }, []);

  const handleRaceChange = (race: string) => {
    setRace(race);
    if (race === 'trolloc' && profession === 'channeler') {
      setProfession('warrior');
    }

    switch (race) {
      case 'human':
        setProfessionOptions(['warrior', 'hunter', 'rogue', 'channeler']);
        break;
      default:
        setProfessionOptions(['warrior', 'hunter', 'rogue']);
        break;
    }    
  }

  const handleProfessionChange = (profession: string) => {
    setProfession(profession);
    if (race === 'trolloc' && profession === 'channeler') {
      setProfession('warrior');
    }
  }

  const handleHomelandClick = (homeland: string) => {
    navigate(`/oldstats/${race}/${profession}/${homeland}`);
  };

  const filteredStats = stats?.filter((x: any) => x.race === race && x.class === profession).sort((a, b) => b.maxTheoreticStatsum - a.maxTheoreticStatsum);

  const summaryView = () => {
    return (
      <>
        <div className="row mb-3">
          <div className="col-12 col-xl-4 mb-3">
            <h5 className="mb-3">WoTMud Stats</h5>
            <select value={race} onChange={e => handleRaceChange(e.target.value)} className="form-select form-select-sm w-auto d-inline me-2">
              <option value="human">human</option>
              <option value="trolloc">trolloc</option>
            </select>
            <select value={profession} onChange={e => handleProfessionChange(e.target.value)} className="form-select form-select-sm d-inline w-auto">
              {professionOptions.map((x, i) => (
                <option key={i} value={x}>{x}</option>  
              ))}
            </select>
          </div>

          <div className="col-12 col-xl-4 mb-3">
            Please also refer to Nalav's stats page:<br/><a href="https://wotmut.gitlab.io/stats" target="_blank" rel="noreferrer">https://wotmut.gitlab.io/stats</a>
          </div>

          <div className="col-12 col-xl-4 mb-3">
            Note: Mudlet users can contribute stats by<br/>downloading the <a href="scripts" className="text-nowrap">Data Collection</a> script.
          </div>
        </div>

        {loading && (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        )}

        {!loading && filteredStats && !filteredStats.length && (
          <div>
            No entries.
          </div>
        )}

        {!loading && filteredStats && !!filteredStats.length && (
          <div className="table-responsive">
            <table className="table table-striped small m-0 table-flex">
              <thead>
                <tr className="smaller">
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Homeland</th>
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Max Stats</th>
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Max Statsum</th>
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Average Stats</th>
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Average Statsum</th>
                  <th className="bg-dark" style={{flex: '1 0 150px'}}>Sample Size</th>
                </tr>
              </thead>
              <tbody>
                {filteredStats.map((stat: any, index) => (
                  <tr key={index}>
                    <td style={{flex: '1 0 150px'}}><button className="btn btn-link p-0 m-0 text-decoration-none" onClick={() => handleHomelandClick(stat.homeland)}>{stat.homelandDisplay}</button></td>
                    <td style={{flex: '1 0 150px'}}>{stat.maxStrength} {stat.maxIntelligence} {stat.maxWillpower} {stat.maxDexterity} {stat.maxConstitution}</td>
                    <td style={{flex: '1 0 150px'}}><div>{stat.maxStatsum} <span className="text-muted small">recorded</span> <br/>{stat.maxTheoreticStatsum} <span className="text-muted small">theoretic</span></div></td>
                    <td style={{flex: '1 0 150px'}}>{stat.averageStrength} {stat.averageIntelligence} {stat.averageWillpower} {stat.averageDexterity} {stat.averageConstitution}</td>
                    <td style={{flex: '1 0 150px'}}><div>{stat.averageStatsum}</div></td>
                    <td style={{flex: '1 0 150px'}}>{stat.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>
    )
  };

  return (
    <>
      {!showDetail && (
        <AppPage pageClass="scripts-page">
          <div className="scripts">
            {summaryView()}
          </div>
        </AppPage>
      )}
      {showDetail && <Outlet/>}
    </>
  );
}

export default StatsPage;